import { useFormContext } from "src/lib/templates";
import { RegisterInitialValue } from "../initialValues";

export const useRegisterFormContext = () => useFormContext<RegisterInitialValue>();
